import React from 'react';

const IconStackOverflow = () => (
  <svg
    fill="#000000"
    width="800px"
    height="800px"
    viewBox="-4 -2 24 24"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMinYMin"
    class="jam jam-stackoverflow">
    <path d="M13.492 18.136v-5.272h1.665v7.022H.13v-7.022h1.665v5.272z" />
    <path d="M3.632 12.364l8.173 1.795.346-1.727-8.173-1.796-.346 1.728zm1.082-4.091l7.567 3.704.692-1.59-7.568-3.728-.691 1.614zm2.097-3.91l6.421 5.614 1.06-1.34L7.87 3.022l-1.06 1.34zM10.962.206L9.622 1.25l4.973 7.045 1.34-1.045L10.962.205zM3.46 16.364h8.346v-1.75H3.46v1.75z" />
  </svg>
);

export default IconStackOverflow;
